(function () {
  function updateLegend(fs, val) {
    const legend = fs && fs.querySelector('legend.form__label');
    if (!legend) return;
    legend.textContent = legend.textContent.replace(/(:\s*).*/, '$1' + val);
  }

  document.addEventListener('change', function (e) {
    const t = e.target;

    // Radio variant pickers
    if (t.matches('input[type="radio"][name]')) {
      if (!t.checked) return;
      const fs = t.closest('fieldset');
      if (!fs) return;
      updateLegend(fs, t.value);
      return;
    }

    // Dropdown variant pickers
    if (t.matches('select[name]')) {
      const fs = t.closest('fieldset');
      if (!fs) return;
      updateLegend(fs, t.value);
      return;
    }
  });

  // On page load, normalize the legends to match current selections
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('fieldset').forEach(function (fs) {
      const checked = fs.querySelector('input[type="radio"][name]:checked');
      if (checked) { updateLegend(fs, checked.value); return; }
      const select = fs.querySelector('select[name]');
      if (select) { updateLegend(fs, select.value); }
    });
  });
})();
